import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import PetitionsForm from './PetitionsForm';
import Notification, { notify } from '../../../common/Notification/Notification';

storiesOf('Advanced Search/Initial Forms/Bankruptcy/Petitions', module)
  .add('View', () => (
    <div className="advanced-search-form">
      <PetitionsForm onSubmit={action('searchGeneral')} onReset={action('resetGeneralSearch')} />
    </div>
  ))
  .add('Search error', () => (
    <div>
      <Notification />
      <PetitionsForm
        onSubmit={(...args) => {
          notify.error('Failed to return Advanced Search results');
          action('searchGeneral')(...args);
        }}
        onReset={action('resetGeneralSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/bankruptcy/PetitionsForm.stories.jsx